export const oktaConfig = {
    oidc: {
        clientId: process.env.VUE_APP_OKTA_CLIENT_ID,
        issuer: process.env.VUE_APP_OKTA_ISSUER, 
        redirectUri: process.env.VUE_APP_OKTA_REDIRECT_URI,
        scopes: ['openid', 'profile', 'email']
    },
    system: {}
}